import { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

function _isFiniteNumber(v) {
  return typeof v === 'number' && Number.isFinite(v);
}

function ClickToSelect({ onSelect }) {
  useMapEvents({
    click(e) {
      if (!e?.latlng) return;
      onSelect({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

function Recenter({ center, zoom }) {
  const map = useMap();

  useEffect(() => {
    if (!Array.isArray(center) || center.length !== 2) return;
    map.setView(center, zoom, { animate: false });
  }, [map, center, zoom]);

  return null;
}

export default function LocationPickerMap({
  value,
  onChange,
  height = 320,
  center,
  zoom = 12,
  label,
}) {
  const hasValue = _isFiniteNumber(value?.lat) && _isFiniteNumber(value?.lng);

  const mapCenter = useMemo(() => {
    if (_isFiniteNumber(center?.lat) && _isFiniteNumber(center?.lng)) return [center.lat, center.lng];
    if (hasValue) return [value.lat, value.lng];
    return [41.0082, 28.9784];
  }, [center?.lat, center?.lng, hasValue, value?.lat, value?.lng]);

  const markerIcon = useMemo(() => {
    return L.divIcon({
      className: 'trendyol-location-pin',
      html:
        '<div style="width:18px;height:18px;border-radius:9999px;background:#f97316;border:3px solid #fff;box-shadow:0 2px 10px rgba(0,0,0,.25)"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
    });
  }, []);

  return (
    <div>
      {label ? <div className="text-sm font-medium mb-2">{label}</div> : null}
      <div style={{ height, width: '100%' }} className="rounded-lg overflow-hidden border-2 border-gray-200">
        <MapContainer center={mapCenter} zoom={zoom} style={{ height: '100%', width: '100%' }}>
          <Recenter center={mapCenter} zoom={zoom} />
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ClickToSelect onSelect={onChange} />
          {hasValue ? (
            <Marker position={[value.lat, value.lng]} icon={markerIcon}>
              <Popup>
                <div className="text-sm">
                  <div>Konum seçildi</div>
                  <div>Lat: {String(value.lat)}</div>
                  <div>Lng: {String(value.lng)}</div>
                </div>
              </Popup>
            </Marker>
          ) : null}
        </MapContainer>
      </div>
    </div>
  );
}
